/* eslint-disable @typescript-eslint/no-non-null-assertion */
// The whole code is copied from VPC.

/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as _ from 'underscore';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import { CommonStyles, textEllipsis } from '../../../../common/styles/CommonStyles';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { CommonColumn } from '../types/Columns';
import { ListViewStyles } from '../ListViewStyles';
import { AppUrls } from '../../../../app/AppUrls';
import { SearchResultItem } from '../../../models/SearchResultTypes';
import { TelemetryService } from '../../../services/TelemetryService';

export interface ILink {
  text: string;
  column?: CommonColumn;
  title?: string;
  url?: string;
  testId?: string;
  style?: any;
  hideTooltips?: boolean;
  iconClassName?: string;
  iconTitle?: string;
  iconUrl?: string;
  beforeTextComponent?: React.ComponentType<IconComponentProps>;
  afterTextComponent?: React.ComponentType<IconComponentProps>;
  openLinkInNewtab?: boolean;
  // This is here so that we don't have multiple layers of factories which doesn't play nice with data grid 3.
  // The bug we are working around is having to click twice on a link for the link to actually receive the click event.
  displayJustText?: boolean;
  isAccessDenied?: boolean;
}

export interface IconComponentProps {
  data: SearchResultItem;
  urls: AppUrls;
}

export function getLinkMarkup(link: ILink, row: DataGrid.Row, searchTerm?: string, total?: number, labelId?: string): JSX.Element {
  // const index = row.data.rowIndex;
  const textEllipsis = CommonStyles.Layout.TextEllipsis;
  const sendTelemetryEvent = searchTerm && total ? () => onResultItemSelected(row, searchTerm, total) : _.noop;
  if (link.column && link.column === CommonColumn.Name) {
    return (
      <a
        href={link.url}
        target={link.openLinkInNewtab ? '_blank' : ''}
        // TBD onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
        title={link.hideTooltips || link.isAccessDenied ? '' : link.title || link.text}
        style={_.extend({ display: 'block' }, textEllipsis, link.style)}
        tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
        aria-labelledby={labelId}
        onClick={sendTelemetryEvent}
      >
        {link.text}
      </a>
    );
  } else {
    return (
      <a
        href={link.url}
        title={link.hideTooltips ? '' : link.title || link.text}
        style={_.extend({ display: 'block' }, textEllipsis, link.style)}
        tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
        onClick={sendTelemetryEvent}
      >
        {link.text}
      </a>
    );
  }
}

const onResultItemSelected = (row: any, searchTerm: string, total: number): void => {
  TelemetryService.instance.sendSearchResultClickedEvent({
    type: 'SearchResultClicked',
    eventSource: 'search-space',
    resultType: row.data.contentType + 's',
    seeAll: false,
    index: row.data.rowIndex + 1,
    total,
    searchTerm: searchTerm,
    contentId: row.data.id,
  });
};

export function LinkCell(
  linkFn: (row: DataGrid.Row) => any,
  tooltip?: boolean,
  siteUrl?: AppUrls,
  searchTerm?: string,
  total?: number
): React.Factory<BodyCell.Props> {
  return StyledCellFormatter(
    React.createFactory(
      // eslint-disable-next-line react/display-name
      class extends React.Component<BodyCell.Props, any> {
        render() {
          const link: ILink = linkFn(this.props.row);
          if (!link || link.isAccessDenied) {
            return null;
          }

          let Icon = null;
          if (link.iconClassName || link.iconTitle) {
            Icon = () => (
              <span
                data-tb-test-id="data-grid-cell-icon"
                className={link.iconClassName}
                title={link.hideTooltips ? '' : link.iconTitle}
                style={{ flex: 'none' }}
              />
            );
          }

          let IconImg = null;
          if (link.iconUrl || link.iconTitle) {
            /* eslint-disable jsx-a11y/alt-text */
            IconImg = () => (
              <img
                data-tb-test-id="data-grid-cell-icon"
                style={ListViewStyles.listViewIconStyle}
                src={link.iconUrl}
                title={link.iconTitle}
              />
            );
          }
          const markup = searchTerm ? getLinkMarkup(link, this.props.row, searchTerm, total) : getLinkMarkup(link, this.props.row);
          return (
            <div data-tb-test-id={link.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {link.beforeTextComponent && siteUrl && (
                <link.beforeTextComponent data={this.props.row.data as SearchResultItem} urls={siteUrl} />
              )}
              {IconImg && <IconImg />}
              {Icon && <Icon />}
              {link.displayJustText && (
                <span
                  title={tooltip || link.hideTooltips ? '' : link.title || link.text}
                  style={_.extend({ display: 'block' }, textEllipsis, link.style)}
                >
                  {/* TBD {tooltip && (
                  <TooltipAnchor
                    tooltipContent={() => <NameToolTip content={this.props.row.data as IDataSourceInfo} urls={spaceUrls} />}
                    disableAutoFocus={true}
                    title={Messages.datasourceDetails()}
                    disableTooltip={false}
                  >
                    {link.text}
                  </TooltipAnchor>
                )} */}
                  {!tooltip && link.text}
                </span>
              )}
              {!link.displayJustText && markup}
              {link.afterTextComponent && siteUrl && (
                <link.afterTextComponent data={this.props.row.data as SearchResultItem} urls={siteUrl} />
              )}
            </div>
          );
        }
      }
    )
  );
}

/* export interface LinkWithCountProps extends BodyCell.Props {
  linkFn: (row: DataGrid.Row) => ILink;
  count?: string;
  getPopoverContent?: (props: BodyCell.Props) => Promise<JSX.Element>;
} */

/* export const LinkWithCount = (props: LinkWithCountProps, siteUrl: AppUrls): JSX.Element => {
  const link = props.linkFn(props.row);
  if (!link) {
    return <></>;
  }

  const textStyles = _.extend({ display: 'block' }, CommonStyles.Layout.TextEllipsis, link.style);

  let icon: JSX.Element | undefined = undefined;

  if (link.iconUrl || link.iconTitle) {
    icon = <img data-tb-test-id="data-grid-cell-icon" style={ListViewStyles.listViewIconStyle} src={link.iconUrl} title={link.iconTitle} />;
  }

  // const datasource = props.row.data as DataSource;
  // const spaceSiteUrl = new AppUrlss({ siteUrlName: datasource.urlName });

  const linkEl: JSX.Element = (
    <a
      href={link.url}
      title={link.hideTooltips ? '' : link.title || link.text}
      tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
      style={textStyles}
    >
      {
        <TooltipAnchor
          tooltipContent={() => <ConnectionToolTip content={props.row.data as IDataSourceInfo} urls={spaceSiteUrl} />}
          disableAutoFocus={true}
          title={Messages.datasourceDetails()}
          disableTooltip={false}
        >
          {link.text}
        </TooltipAnchor>
      }
      {link.text}
    </a>
  );

  const getContent = props.getPopoverContent ? () => props.getPopoverContent!(props) : undefined;
  return (
    <CellWithCountAndToolTip count={props.count} testId={link.testId} getPopoverContent={getContent}>
      {icon}
      {linkEl}
    </CellWithCountAndToolTip>
  );
 };*/
